import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  type_person: { id: 'orderer.type_person', defaultMessage: 'person' },
  type_company: { id: 'orderer.type_company', defaultMessage: 'company' },
  delivery_method_mail: { id: 'orderer.delivery_method.mail', defaultMessage: 'Mail' },
  email: { id: 'orderer.delivery_method.email', defaultMessage: 'Email' },
  e_invoice: { id: 'orderer.delivery_method.e_invoice', defaultMessage: 'E-invoice' },
  no_delivery: { id: 'orderer.delivery_method.no_delivery', defaultMessage: 'No delivery' },
  heading: { id: 'orderer.heading', defaultMessage: 'Orderer information' },
  ssn: { id: 'orderer.ssn', defaultMessage: 'Personal identity code' },
  search: { id: 'orderer.search', defaultMessage: 'Search' },
  lastName: { id: 'orderer.lastName', defaultMessage: 'Last name' },
  name: { id: 'orderer.name', defaultMessage: 'Name' },
  firstName: { id: 'orderer.firstName', defaultMessage: 'First names' },
  phone: { id: 'orderer.phone', defaultMessage: 'Phone number' },
  emailAddress: { id: 'orderer.email', defaultMessage: 'Email' },
  clear: { id: 'orderer.clear', defaultMessage: 'Clear' },
  edit: { id: 'orderer.edit', defaultMessage: 'Edit' },
  addToRegistry: { id: 'orderer.addToRegistry', defaultMessage: 'Save to customer register' },
  selectPlaceholder: { id: 'orderer.selectPlaceholder', defaultMessage: 'Valitse...' },
  companyName: { id: 'orderer.companyName', defaultMessage: 'Yrityksen nimi' },
  contactPerson: { id: 'orderer.contactPerson', defaultMessage: 'Yhteyshenkilö' },
  contactPersonPhone: { id: 'orderer.contactPersonPhone', defaultMessage: 'Yhteyshenkilön puhelinnumero' },
  contactPersonEmail: { id: 'orderer.contactPersonEmail', defaultMessage: 'Yhteyshenkilön sähköposti' },
  vehicleDataPlaceholder: { id: 'orderer.vehicleDataPlaceholder', defaultMessage: 'Ajoneuvotiedoista' },
  ownerInfoErrorTitle: { id: 'orderer.ownerInfoErrorTitle', defaultMessage: 'Virhe' },
  ownerInfoErrorMessage: {
    id: 'orderer.ownerInfoErrorMessage',
    defaultMessage: 'Omistajatietoa ei saatavilla. Täytä tiedot käsin',
  },
  identifier: { id: 'orderer.identifier', defaultMessage: 'Asiakastunniste' },
  businessId: { id: 'orderer.businessId', defaultMessage: 'Y-tunnus' },
  company: { id: 'orderer.company', defaultMessage: 'Yritys' },
  address: { id: 'orderer.address', defaultMessage: 'Osoite' },
  zipcode: { id: 'orderer.zipcode', defaultMessage: 'Postinumero' },
  city: { id: 'orderer.city', defaultMessage: 'Toimipaikka' },
  eInvoiceAddress: { id: 'orderer.eInvoiceAddress', defaultMessage: 'Verkkolaskuosoite' },
  eInvoiceOperator: { id: 'orderer.eInvoiceOperator', defaultMessage: 'Verkkolaskuoperaattori' },
  deliveryMethodLabel: { id: 'orderer.deliveryMethodLabel', defaultMessage: 'Laskun lähetystapa' },
  extraInfo: { id: 'orderer.extraInfo', defaultMessage: 'Lisätieto (laskun osoiteriville)' },
  notificationMethod: { id: 'orderer.notificationMethod', defaultMessage: 'Seurantalinkin lähetys' },
  notes: { id: 'orderer.notes', defaultMessage: 'Muistiinpanot' },
  save: { id: 'orderer.save', defaultMessage: 'Tallenna' },
  close: { id: 'orderer.close', defaultMessage: 'Sulje' },
  customerRegistryHeading: {
    id: 'orderer.customerRegistryHeading',
    defaultMessage: 'Asiakasrekisteri: {name}',
  },
})
